import { styled } from '@mui/material/styles';
import { Dialog } from '@mui/material';

export const DialogoBoostrap = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: '10px 12px',
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));